import palette from '@lib/core/src/theme/palette';
import { Box, Divider, Stack, Typography } from '@mui/material';

import { Section } from '@/api/generated';

const sectionIcons: Record<string, string> = {
  Brief: '📌',
  'Sentiment Analysis': '🤝',
  'Open Questions': '📣',
  'Important Issues': '⚠️',
  'Action Items': '✅'
};

export const AgentTemplatePreview = ({
  sections
}: {
  sections: (Section & { example?: string })[];
}) => (
  <Stack
    sx={{
      borderLeft: `1px solid ${palette.grey[1200]}`,
      background: `linear-gradient(180deg, rgba(230, 227, 255, 0.05) 0%, rgba(237, 163, 254, 0.05) 32%, rgba(61, 85, 255, 0.05) 72.5%, rgba(86, 114, 230, 0.05) 100%), ${palette.white}`,
      padding: {
        md: '0 8px 0px 8px',
        lg: '0 24px 0px 20px'
      },
      borderTopRightRadius: '16px',
      flex: 1
    }}
  >
    <Typography sx={{ marginTop: '8px', marginLeft: '20px', color: palette.black }}>
      Preview
    </Typography>

    <Stack
      sx={{
        margin: 'auto',
        padding: '20px',
        gap: '16px',
        background: palette.white,
        boxShadow: `0px 8px 22px -6px rgba(24, 39, 75, 0.12), 0px 14px 64px -4px rgba(24, 39, 75, 0.12)`,
        borderRadius: '16px',
        width: '421px',
        maxHeight: '700px',
        overflowY: 'auto'
      }}
    >
      {sections?.map((section, index) => (
        <>
          {index !== 0 && <Divider />}
          <Stack key={section.index} gap={'12px'}>
            <Typography
              sx={{
                color: palette.grey[500],
                fontSize: '16px',
                fontWeight: 600,
                display: 'flex',
                gap: '4px',
                alignItems: 'center'
              }}
            >
              {section.title && sectionIcons[section.title] ? (
                <div style={{ fontSize: '14px' }}>{sectionIcons[section.title]} </div>
              ) : (
                ''
              )}
              {section.title}
            </Typography>
            <Typography sx={{ color: palette.grey[500], fontSize: '13px', fontWeight: 500 }}>
              {section.example}
            </Typography>
          </Stack>
        </>
      ))}
    </Stack>
  </Stack>
);
